import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { BlockAudioComponent } from '@app/components/blocks/block-audio/block-audio.component';
import { PlAudioModule } from '@app/components/pl-audio/pl-audio.module';

@NgModule({
  imports: [CommonModule, SharedModule, PlAudioModule],
  declarations: [BlockAudioComponent],
  exports: [BlockAudioComponent],
})
export class BlockAudioModule {}
